import { render, staticRenderFns } from "./TemplatesPage.vue?vue&type=template&id=849099d8&scoped=true"
import script from "./TemplatesPage.vue?vue&type=script&lang=js"
export * from "./TemplatesPage.vue?vue&type=script&lang=js"
import style0 from "./TemplatesPage.vue?vue&type=style&index=0&id=849099d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849099d8",
  null
  
)

export default component.exports